<template>
    <div class="channel" :style="styles">
        <el-row>
            <el-col :span="4" align="left">
                <!-- 增加审核逻辑 -->
                <avatar v-if="!showAvatar && profile.name != null" :hash="profile.name" :isDefaultRotate="false" :size="avatarSize"></avatar>
                <avatar v-else-if="showAvatar" :url="profile.avatar" :isDefaultRotate="false" :size="avatarSize"></avatar>
            </el-col>
            <!-- line-height 可以使得文字高度居中，45px 是头像的高度，统一设置即可，-->
            <el-col :span="14" align="left">
                <el-tooltip class="item" effect="dark" content="进入我的空间" :value="isShowProfileTooltip" placement="top" :manual="true">
                    <!-- 这里的 display: inline-block 是关键属性，它让 name 自适应宽度，有多长显示多长，否则会占满整行导致 tooltip 定位不准确 -->
                    <profile-name
                            :name="profile.name"
                            :code="profile.code"
                            :style-object="{lineHeight: '30px', fontWeight: '600', fontSize: '14px', display: 'inline-block'}" />
                </el-tooltip>
                <div style="display: flex; display: -webkit-flex; align-items: center">
                    <el-tooltip class="item" effect="dark" :manual="true" :value="isShowLocationTooltip" :content="location" placement="top">
                        <div class="location" v-if="location !== null" :title="location" id="location" @click="showLocationTooltip">{{location}}</div>
                    </el-tooltip>
                    <input :value="location" readonly style="position: fixed; left:-1000px; top:-1000px" id="location-for-copy"></input>
                    <i v-if="location !== null" class="el-icon-copy-document" style="margin: 0 4px 0 8px" @click="copy"></i>
                </div>
                <!-- 误删：测试 location 超长 -->
                <!-- <div class="location" title="美国加利福利亚州加利福利亚地区加利福利亚县城">美国加利福利亚州加利福利亚地区加利福利亚县城</div> -->
            </el-col>
            <el-col :span="6" class="bookmark" style="border:0px solid black">
                <!-- TODO 将文字和 iconfont 的方式二和为一 -->
                <div style="display:inline-flex; align-items:center; width: 100%;">
                    <follows :font-size="14" :line-height="30" :isButton="false" :code="profile.code" style="width: 60%" v-if="profile.code !== null"></follows>
                    <!-- follows 占位符-->
                    <div v-else style="width:60%; color:#909399">...</div>
                    <wallpaper-previewer style="width:40%;"></wallpaper-previewer>
                    <!-- 解锁下面的这个使用 inconfont -->
                    <!-- <profile-follows_ :font-size="30" :line-height="35"></profile-follows_>-->
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import ProfileName from "../../profile/Name";
    import Follows from "../../profile/Follows";
    import {isPhoneAgent, Styles, HTML, successMessage} from "../../../utils";
    import WallpaperPreviewer from "../../commons/WallpaperPreviewer";

    export default {
        name: "ProfileSection",
        components: {
            WallpaperPreviewer,
            Follows,
            ProfileName
        },
        props: {
            avatarSize: Number,
            styles: Object,
            profile: null,
            location: String,
            isFollowed: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isShowProfileTooltip: false,
                isShowLocationTooltip: false,
            }
        },
        computed: {
            showAvatar(){
                if (this.$store.state.displayCtrl !== null){
                    return this.$store.state.displayCtrl.avatar;
                }else{
                    return false;
                }
            }
        },
        created(){
            setTimeout(()=>{
                this.showProfileTooltip();
            }, 5000)
        },
        methods: {
            /**
             * 当且仅当 ellipsis 后才可以提示
             */
            showLocationTooltip(){
                if (Styles.isEllipsis('location')){
                    this.isShowLocationTooltip = true;
                    setTimeout(()=>{
                        this.isShowLocationTooltip = false;
                    }, 2000)
                }
            },
            showProfileTooltip(){
                if (this.$store.state.tutorial.profilePreview.currentPreviews < this.$store.state.tutorial.profilePreview.maxPreviews
                    && this.profile.code !== this.$store.state.tutorial.profilePreview.preProfileCode
                    && isPhoneAgent()){
                    this.isShowProfileTooltip = true;
                    this.$store.commit('setTutorialPreProfileCode', this.profile.code);
                    this.$store.commit('incTutorialProfilePreviews')
                    setTimeout(()=>{
                        this.isShowProfileTooltip = false;
                    }, 3000)
                }
            },
            /**
             * 拷贝 location
             */
            copy(){
                HTML.copy('location-for-copy');
                successMessage('拷贝成功');
            }
        }
    }
</script>
<style scoped>

    .channel {
        padding-bottom: 10px;
    }

    .channel .title{
        line-height:30px; /* 能够将 Profile name 垂直居中显示 */
        font-size:14px;
        font-weight:600;
        cursor: pointer
    }

    /* 切记，hover 事件只在 PC 端添加，否则 IOS H5 会出现 double click link 才能生效的问题 */
    @media (min-width: 736px) {
        .channel .title:hover {
            color: #CB0101; /* Constants red color*/
        }
    }

    .channel .location{
        line-height:15px;
        height: 15px;
        font-size: 12px;
        color: #E6A23C;
        cursor: pointer;
        /* 下面三个属性是设置 text-overflow 的关键*/
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    /* 切记，hover 事件只在 PC 端添加，否则 IOS H5 会出现 double click link 才能生效的问题 */
    @media (min-width: 736px) {
        .bookmark .el-icon-star-off:hover {
            color: #E6A23C; /* warning style of default element ui */
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/entity/infoboard/ProfileSection.vue